import React, { Component } from 'react'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import Tags from '../tags'
import Recommendtop from '../recommendtop'
import * as styles from './card.module.css'

export default class Card extends Component {

  render() {
    const post = this.props.post
    const slug = post.node.fields.slug;
    const actress = post.node.frontmatter.actress
    const title = post.node.frontmatter.title
    const tags = post.node.frontmatter.tags
    const name = post.node.frontmatter.name
    const recommend = post.node.frontmatter.recommend
    const image = getImage(post.node.frontmatter.thumbnail)

    return (
      <Link to={slug}>
        <div className={styles.card}>
          <div className={styles.card_capture}>
            <GatsbyImage image={image} alt={name} />
          </div>
          <div className={styles.card_lecture}>
            <div className={styles.card_date}>
              <span className={styles.date_icon}>
                <StaticImage
                  layout="fixed"
                  formats={["AUTO", "WEBP", "AVIF"]}
                  src="../../../images/date.png"
                  width={16}
                  height={16}
                  style={{ zIndex: "1", marginTop: `7px`, marginRight: `4px` }}
                  alt="ALL"
                />
              </span>
              <span className={styles.post_date}>{post.node.frontmatter.date}</span>
              <span><Recommendtop recommend={recommend} /></span>
            </div>
            <div className={styles.card_title}>{title}</div>
            <Link to={`/actress/${kebabCase(actress)}/`}>
              <div className={styles.card_actress}>{actress}</div>
            </Link>
            <div className={styles.tags_area}>
              <Tags tags={tags} short={true} />
            </div>
          </div>
        </div>
      </Link>
    )
  }
}